import { theme } from "../../../tailwind.config"

export const useBreakpoints = (key) => {
  const mediaQuery = window.matchMedia(`(min-width: ${theme.screens[key]})`)
  return mediaQuery.matches
}
